<template>
  <div>
    <div class="van-nav-bar van-hairline--bottom" style="z-index: 1;">
      <div class="van-nav-bar__left" @click="onCancel">
        <i class="van-icon van-nav-bar__arrow van-icon-arrow"><!----></i>
        <span class="van-nav-bar__text">返回</span>
      </div>
      <div class="van-nav-bar__title van-ellipsis">
        <div class="van-search__input-wrap" style="margin-top: 5px;margin-left: 20px;">
          <i class="van-icon van-icon-search"><!----></i>
          <input v-model="searchKeyword" type="search" class="van-search__input">
        </div>
      </div>
      <div class="van-nav-bar__right" @click="onSearch">
        <span class="van-nav-bar__text">搜索</span>
      </div>
    </div>

    <div>
      <section class="van-doc-demo-block">
        <h2 class="van-doc-demo-block__title">{{ searches.order?searches.order.name:'' }}</h2>
        <div style="margin-left: 10px;margin-right: 5px;">
          <label :for="'order'+item.key" v-for="item in searches.order?searches.order.list:[]" :key="item.key">
            <van-tag :type="searchOrder == item.key ? 'success' : '' " class="radio-order-tag">{{ item.value }}</van-tag>
            <input type="radio" v-model="searchOrder"  :id="'order'+item.key" :value="item.key" style="display: none"/>
          </label>
        </div>
      </section>

      <section v-if="searches.order" class="van-doc-demo-block">
        <h2 class="van-doc-demo-block__title">时间段选择</h2>
        <div style="margin-left: 10px;margin-right: 5px;">
          <van-row>
            <van-col span="9"><van-field  v-model="searchStartTime" placeholder="开始时间" v-on:focus="onShowStartTime"/></van-col>
            <van-col span="2" style="line-height: 40px;">-</van-col>
            <van-col span="9"><van-field v-model="searchEndTime" placeholder="截止时间" v-on:focus="onShowEndTime"/></van-col>
          </van-row>
        </div>
      </section>

      <section class="van-doc-demo-block">
        <h2 class="van-doc-demo-block__title">总价预算范围</h2>
        <div style="margin-left: 10px;margin-right: 5px;">
          <label :for="'totalBudgetRange'+index" v-for="(text, index) in options.total_budget_range?options.total_budget_range.list:[]" :key="index">
            <van-tag :type="searchTotalBudgetRange.indexOf(index) !== -1 ? 'primary' : '' " class="checkbox-tag">{{ text }}</van-tag>
            <input type="checkbox" v-model="searchTotalBudgetRange" :id="'totalBudgetRange'+index" :value="index" style="display: none"/>
          </label>
        </div>
      </section>

      <section class="van-doc-demo-block">
        <h2 class="van-doc-demo-block__title">单价接受程度</h2>
        <div style="margin-left: 10px;margin-right: 5px;">
          <label :for="'priceAcceptanceLevel'+index" v-for="(text, index) in priceAcceptanceLevelList" :key="index">
            <van-tag :type="searchPriceAcceptanceLevel.indexOf(index) !== -1 ? 'primary' : '' " class="checkbox-tag">{{ text }}</van-tag>
            <input type="checkbox" v-model="searchPriceAcceptanceLevel" :id="'priceAcceptanceLevel'+index" :value="index" style="display: none"/>
          </label>
        </div>
      </section>

      <section v-if="searches.status" class="van-doc-demo-block">
        <h2 class="van-doc-demo-block__title">{{ searches.status?searches.status.name:'' }}</h2>
        <div style="margin-left: 10px;">
          <label :for="'status0'">
            <van-tag :type="searchStatus == 0 ? 'success' : '' " class="radio-tag">全部</van-tag>
            <input type="radio" v-model="searchStatus"  :id="'status0'" :value="0" style="display: none"/>
          </label>
          <label :for="'status'+item.key" v-for="item in searches.status?searches.status.list:[]" :key="item.key">
            <van-tag :type="searchStatus == item.key ? 'success' : '' " class="radio-tag">{{ item.value }}</van-tag>
            <input type="radio" v-model="searchStatus"  :id="'status'+item.key" :value="item.key" style="display: none"/>
          </label>
        </div>
      </section>

      <section v-if="searches.labels" class="van-doc-demo-block">
        <h2 class="van-doc-demo-block__title">{{ searches.labels?searches.labels.name:'' }}</h2>
        <div style="margin-left: 10px;">
          <label :for="'labels0'">
            <van-tag :type="searchLabels == 0 ? 'success' : '' " class="radio-tag">全部</van-tag>
            <input type="radio" v-model="searchLabels"  :id="'labels0'" :value="0" style="display: none"/>
          </label>
          <label :for="'labels'+item.key" v-for="item in searches.labels?searches.labels.list:[]" :key="item.key">
            <van-tag :type="searchLabels == item.key ? 'success' : '' " class="radio-tag">{{ item.value }}</van-tag>
            <input type="radio" v-model="searchLabels"  :id="'labels'+item.key" :value="item.key" style="display: none"/>
          </label>
        </div>
      </section>

      <section class="van-doc-demo-block">
        <h2 class="van-doc-demo-block__title">用途</h2>
        <div style="margin-left: 10px;margin-right: 5px;">
          <label :for="'purposeV2'+index" v-for="(text, index) in options.purpose_v2?options.purpose_v2.list:[]" :key="index">
            <van-tag :type="searchPurposeV2.indexOf(index) !== -1 ? 'primary' : '' " class="checkbox-tag">{{ text }}</van-tag>
            <input type="checkbox" v-model="searchPurposeV2" :id="'purposeV2'+index" :value="index" style="display: none"/>
          </label>
        </div>
      </section>

      <section class="van-doc-demo-block">
        <h2 class="van-doc-demo-block__title">客户来源</h2>
        <div style="margin-left: 10px;margin-right: 5px;">
          <label :for="'sourceChannelV2'+index" v-for="(text, index) in options.source_channel_v2?options.source_channel_v2.list:[]" :key="index">
            <van-tag :type="searchSourceChannelV2.indexOf(index) !== -1 ? 'primary' : '' " class="checkbox-tag">{{ text }}</van-tag>
            <input type="checkbox" v-model="searchSourceChannelV2" :id="'sourceChannelV2'+index" :value="index" style="display: none"/>
          </label>
        </div>
      </section>

      

      <section class="van-doc-demo-block">
        <h2 class="van-doc-demo-block__title">{{ searches.employee?searches.employee.name:'' }}</h2>
        <div style="margin-left: 10px;margin-right: 5px;">
          <label :for="'employee'+item.key" v-for="item in searches.employee?searches.employee.list:[]" :key="item.key">
            <van-tag :type="searchEmployees.indexOf(item.key) !== -1 ? 'primary' : '' " class="checkbox-tag">{{ item.value }}</van-tag>
            <input type="checkbox" v-model="searchEmployees"  :id="'employee'+item.key" :value="item.key" style="display: none"/>
          </label>
        </div>
      </section>
    </div>

    <calendar v-model="showStartTime" :defaultDate="currentDate" @change="setStartTime"></calendar>
    <calendar v-model="showEndTime" :defaultDate="currentDate" @change="setEndTime"></calendar>
  </div>
</template>

<script>
  export default {
    components:{
    },
    data(){
      return{
        searches:[],
        options: [],
        searchStatus:this.$store.state.search.searchStatus,
        searchLabels:this.$store.state.search.searchLabels,
        searchKeyword: this.$store.state.search.searchKeyword,
        searchTotalBudgetRange:this.$store.state.search.searchTotalBudgetRange || [],
        searchPriceAcceptanceLevel:this.$store.state.search.searchPriceAcceptanceLevel || [],
        searchSourceChannelV2:this.$store.state.search.searchSourceChannelV2 || [],
        searchPurposeV2:this.$store.state.search.searchPurposeV2 || [],
        searchEmployees:this.$store.state.search.searchEmployees,
        searchOrder:this.$store.state.search.searchOrder,
        searchStartTime:this.$store.state.search.searchStartTime,
        searchEndTime:this.$store.state.search.searchEndTime,

        showStartTime:false,
        showEndTime:false,
        currentDate: new Date(),
      }
    },
    computed: {
      priceAcceptanceLevelList() {
        const list = this.options.price_acceptance_level ? this.options.price_acceptance_level.list : []
        return list
      }
    },
    methods:{
      onCancel() {
        this.$store.state.search.isSearch = false
        this.$router.back(-1);
      },
      onSearch() {
        this.$store.state.search.isSearch = true
        this.$router.push('/customer');
      },
      onShowStartTime(){
        document.activeElement.blur();
        this.showStartTime = true
        this.showEndTime = false
      },
      onShowEndTime(){
        document.activeElement.blur();
        this.showStartTime = false
        this.showEndTime = true
      },
      setStartTime(date,formatDate){
        document.activeElement.blur();
        this.searchStartTime = formatDate
        this.$store.state.search.searchStartTime = formatDate;
        this.showStartTime = false
        this.showEndTime = false
      },
      setEndTime(date,formatDate){
        document.activeElement.blur();
        this.searchEndTime = formatDate
        this.$store.state.search.searchEndTime = formatDate;
        this.showStartTime = false
        this.showEndTime = false
      },
    },
    watch: {
      '$route' (to, from) {
        if (to.name === 'customer-search') {
          window.scroll(0, 0)
        }
      },
      searchStatus: function (val) {
        this.$store.state.search.searchStatus = val;
      },
      searchLabels: function (val) {
        this.$store.state.search.searchLabels = val;
      },
      searchKeyword: function (val) {
        this.$store.state.search.searchKeyword = val;
      },
      searchTotalBudgetRange: function (val) {
        this.$store.state.search.searchTotalBudgetRange = val;
      },
      searchPriceAcceptanceLevel: function (val) {
        this.$store.state.search.searchPriceAcceptanceLevel = val;
      },
      searchSourceChannelV2: function (val) {
        this.$store.state.search.searchSourceChannelV2 = val;
      },
      searchPurposeV2: function (val) {
        this.$store.state.search.searchPurposeV2 = val;
      },
      searchEmployees: function (val) {
        this.$store.state.search.searchEmployees = val;
      },
      searchOrder: function (val) {
        this.$store.state.search.searchOrder = val;
      },
      searchStartTime: function (val) {
        this.$store.state.search.searchStartTime = val;
      },
      searchEndTime: function (val) {
        this.$store.state.search.searchEndTime = val;
      },
    },
    created:function(){
      window.scroll(0, 0)

      // 获取 options 数据
      if(this.$store.state.customer.state.options.status){
        this.options = this.$store.state.customer.state.options
      }else {
        this.$api.post('/api/base/options',null,
          r => {
            this.$store.state.customer.state.options = r.data
            this.options = r.data
          })
      }

      // 获取 searches 数据（用于 status、labels、employee）
      if(this.$store.state.customer.state.searches.status){
        this.searches = this.$store.state.customer.state.searches
      }else {
        this.$api.post('/api/base/searches',null,
          r => {
            this.searches = r.data
            this.$store.state.customer.state.searches = r.data
          })
      }
    },
  }
</script>

<style scoped>
  .van-doc-demo-block__title {
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    color: rgba(69,90,100,.6);
    padding: 10px 10px 5px;
  }
  .radio-order-tag{
    width: 31.5%;
    height: 36px;
    text-align: center;
    line-height: 36px;
    font-size: 14px;
    display: inline-block;
    box-sizing: border-box;
    margin-bottom: 5px;
  }
  .radio-tag{
    width: 23%;
    height: 36px;
    text-align: center;
    line-height: 36px;
    font-size: 14px;
    display: inline-block;
    padding: 0;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .radio-tag:nth-child(4n){
    margin-right: 0;
  }

  .checkbox-tag{
    text-align: center;
    height: 36px;
    line-height: 36px;
    width: 23%;
    font-size: 14px;
    display: inline-block;
    padding: 0;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .checkbox-tag:nth-child(4n){
    margin-right: 0;
  }
  .van-search__input {
    display: block;
    width: 100%;
    height: 16px;
    line-height: 16px;
    padding: 0;
    font-size: 14px;
    color: #666;
    border: none;
  }
  .van-icon-search {
    color: #666;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 10px;
    font-size: 16px;
  }
  .van-nav-bar .van-icon {
    color: #38f;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/search.vue